import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {TherapeuticIndicationApi} from '../../../apis/TherapeuticIndicationApi/TherapeuticIndicationApi';
import {ITherapeuticIndication} from '../TherapeuticIndication';

export function useGetTherapeuticIndications() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.therapeuticIndication],
        queryFn: async (): Promise<ITherapeuticIndication[]> => {
            return await TherapeuticIndicationApi.getAll();
        },
    });
} 